var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-body',[_c('b-form-group',{attrs:{"label":"Channel Name"}},[_c('b-input',{model:{value:(_vm.channel.name),callback:function ($$v) {_vm.$set(_vm.channel, "name", $$v)},expression:"channel.name"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }